import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const relatorioRmsRoutes: Routes = [
  {
    path: 'consultar-rms/relatorio-rms',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./relatorio-rms.component').then((m) => m.RelatorioRmsComponent),
        data: {
          title: 'Relatório RMS',
          roles: [Role.RELATORIO_RMS_VISUALIZAR],
          breadcrumb: [
            { label: 'Consultar RMS', url: '/consultar-rms' },
            { label: 'Relatório RMS', url: '/consultar-rms/relatorio-rms' },
          ],
        },
      },
    ],
  },
];
